export default __webpack_public_path__ + "static/media/vr-2.4de8ab21.png";